var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.prefixCls + "-operation" },
    [
      _vm.reverseOperation
        ? [
            _c(
              "i-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  disabled: !_vm.leftActive
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.moveToRight.apply(null, arguments)
                  }
                }
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.operations[1]))]),
                _vm._v(" "),
                _c("Icon", { attrs: { type: "ios-arrow-forward" } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "i-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  disabled: !_vm.rightActive
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.moveToLeft.apply(null, arguments)
                  }
                }
              },
              [
                _c("Icon", { attrs: { type: "ios-arrow-back" } }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.operations[0]))])
              ],
              1
            )
          ]
        : [
            _c(
              "i-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  disabled: !_vm.rightActive
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.moveToLeft.apply(null, arguments)
                  }
                }
              },
              [
                _c("Icon", { attrs: { type: "ios-arrow-back" } }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.operations[0]))])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "i-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  disabled: !_vm.leftActive
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.moveToRight.apply(null, arguments)
                  }
                }
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.operations[1]))]),
                _vm._v(" "),
                _c("Icon", { attrs: { type: "ios-arrow-forward" } })
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32dfac46", { render: render, staticRenderFns: staticRenderFns })
  }
}